/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierSalesProfile.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/carrier-sales-profile";

export class AutogenModelCarrierSalesProfile<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierSalesProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierSalesProfile extends ModelRow<RowCarrierSalesProfileFields> {
	constructor(values?: Partial<RowCarrierSalesProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierSalesProfileFields {
	act_days: number;
	act_type: string;
	carrier_id: string;
	carrier_rep_id: string;
	company_id: string;
	descr: string;
	id: string;
	sales_manager_id: string;
	salesperson_id: string;
	status: string;
}

